"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var render = function render() {
  var _context, _context2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-selfuser kiwi-theme-bg"
  }, [!_vm.self_user_settings_open ? _c('div', {
    staticClass: "kiwi-selfuser-mask"
  }, [_c('span', {
    staticClass: "kiwi-selfuser-nick"
  }, [_c('away-status-indicator', {
    attrs: {
      "network": _vm.network,
      "user": _vm.user
    }
  }), _vm._v(" " + _vm._s(_vm.network.nick) + " "), _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function click($event) {
        return _vm.closeSelfUser();
      }
    }
  }), _c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function click($event) {
        return _vm.openSelfActions();
      }
    }
  }), _c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function click($event) {
        return _vm.openProfile();
      }
    }
  })], 1), !(0, _includes.default)(_context = _vm.modeString).call(_context, 'r') ? _c('span', {
    staticClass: "kiwi-selfuser-register"
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('selfuser_register_link'),
      "title": "Registrati",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('selfuser_register_text')))])]) : _vm._e(), (0, _includes.default)(_context2 = _vm.modeString).call(_context2, 'r') ? _c('span', {
    staticClass: "kiwi-selfuser-register"
  }, [_c('button', {
    staticClass: "kiwi-selfuser-avatar",
    attrs: {
      "title": "Imposta Avatar",
      "target": "_blank"
    },
    on: {
      "click": function click($event) {
        return _vm.setAvatar();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(_vm._s(_vm.$t('selfuser_avatar_text')))])]) : _vm._e(), _c('span', {
    staticClass: "kiwi-selfuser-host"
  }, [_vm._v(" " + _vm._s(_vm.user.username) + "@" + _vm._s(_vm.user.host) + " "), _vm.modeString ? [_vm._v(" ( " + _vm._s(_vm.modeString) + " ) ")] : _vm._e()], 2), _vm.networkSupportsAway() ? _c('div', {
    staticClass: "u-form kiwi-away-checkbox-form"
  }, [_c('label', {
    staticClass: "kiwi-selfuser-away-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('away')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.awayStatus,
      expression: "awayStatus"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.awayStatus) ? _vm._i(_vm.awayStatus, null) > -1 : _vm.awayStatus
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.awayStatus,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.awayStatus = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context3;
            $$i > -1 && (_vm.awayStatus = (0, _concat.default)(_context3 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context3, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.awayStatus = $$c;
        }
      }
    }
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "kiwi-selfuser-actions"
  }, [_vm.error_message ? _c('div', {
    staticClass: "kiwi-selfuser-error-message"
  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e(), _c('input-prompt', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "label": _vm.$t('enter_new_nick'),
      "block": true
    },
    on: {
      "submit": _vm.onNewNickSubmit,
      "cancel": _vm.closeNickChange
    }
  })], 1)]);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;